import React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
  currencyFormat
} from "../../services/shareconstant";
export default function EOIDetails(props) {
  const ApprovedCost = (props) => {  
    const cost = parseFloat(props.dataItem.ApprovedAmount).toFixed(2);
    return <td>{currencyFormat(cost)}</td>;
  };
  const ElectedAmountCost = (props) => {  
    const cost = parseFloat(props.dataItem.ElectedAmount).toFixed(2);
    return <td>{currencyFormat(cost)}</td>;
  };
  const AmountPendingEOI = (props) => {  
    const cost = parseFloat(props.dataItem.AmountPendingEOI).toFixed(2);
    return <td>{currencyFormat(cost)}</td>;
  };
  
  return (
    props.data[0] ? (<div className="page-wrapper eoi-details">
        <div className="heading-form">Benefits Pending Approval</div>  <br />
        <div className="mb-3 styledGrid EOIRequestGrid">
        <Grid data={props.data}>
         
          <Column field="ElectedPlan" title="Elected Plan" />
          <Column cell={ElectedAmountCost}   title="Elected Amount" />
          <Column  cell={ApprovedCost}   title="Approved Amount" />
          <Column  cell={AmountPendingEOI}   title="Amount Pending EOI" />
        
        </Grid>
        </div>
    </div>) : (
        <div>
            <div className="heading-form">Benefits Pending Approval</div>  <br />
            <p>You do not have pending EOI for any plan</p> <br /> </div>
    )
);
}